import { useTheme } from "@mui/material";
import { useEffect } from "react";
import { pilotGoalStorageKey } from "web_myplann/Utils/WebViewModel";

export const usePilotPageBackground = (pilotGoal: boolean | undefined) => {
	const {
		palette: { grey },
	} = useTheme();

	useEffect(() => {
		if (pilotGoal === undefined) {
			return;
		}

		try {
			localStorage.setItem(pilotGoalStorageKey, String(pilotGoal));
		} catch {}

		if (!pilotGoal) {
			document.body.style.removeProperty("background-color");
			document.documentElement.style.removeProperty("background-color");
			return;
		}

		document.body.style.backgroundColor = grey[50];
		document.documentElement.style.backgroundColor = grey[50];
	}, [pilotGoal, grey[50]]);
};
